/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} My_Payments_Subscription_EndsInputs */

const en_my_payments_subscription_ends = /** @type {(inputs: My_Payments_Subscription_EndsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ends ${i?.date}`)
};

const pl_my_payments_subscription_ends = /** @type {(inputs: My_Payments_Subscription_EndsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kończy się ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Ends {date}" |
*
* @param {My_Payments_Subscription_EndsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_subscription_ends = /** @type {((inputs: My_Payments_Subscription_EndsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Subscription_EndsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_subscription_ends(inputs)
	return en_my_payments_subscription_ends(inputs)
});